import { render, staticRenderFns } from "./PermissionsGrantedDialog.vue?vue&type=template&id=d7b7679a&"
import script from "./PermissionsGrantedDialog.vue?vue&type=script&lang=js&"
export * from "./PermissionsGrantedDialog.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsGrantedDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports